import React, { ElementType, FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useAuthStore } from '~/stores';
import { RoutesPath } from '~/types';

interface PrivateRouteProps {
  component: ElementType;
  strict?: boolean;
  path: string;
  exact?: boolean;
}

export const PrivateRoute: FC<PrivateRouteProps> = ({
  // eslint-disable-next-line @typescript-eslint/naming-convention
  component: Component,
  strict = false,
  ...rest
}) => {
  const { user } = useAuthStore();

  return (
    <Switch>
      <Route
        {...rest}
        strict={strict}
        render={() => {
          if (user) {
            return <Component {...rest} />;
          } else {
            return (
              <Redirect
                to={{
                  pathname: RoutesPath.Login,
                  state: { from: location.pathname },
                }}
              />
            );
          }
        }}
      />
    </Switch>
  );
};
